module.exports = __webpack_public_path__ + "img/instagram.6c2ab5fb.svg";